module.exports = __webpack_public_path__ + "img/p_icon02.3ec54a50.svg";